
<div style="height: auto; max-height: 70vh">
  <div
    class="flex justify-content-center align-items-center mt-3 mb-3"
    *ngIf="isSwitcherCropperActive"
  >
    <span>Rectangle</span>
    <p-toggleswitch
      class="ml-1 mr-1 round-cropper-switch"
      (onChange)="onToggleRoundCropper($event)"
      [(ngModel)]="isRoundCropper"
    ></p-toggleswitch>
    <span>Circle</span>
  </div>

  <image-cropper
    (imageCropped)="onImageCropped($event)"
    (imageLoaded)="onImageLoaded()"
    (loadImageFailed)="onLoadImageFailed()"
    (wheel)="onWheel($event)"
    [aspectRatio]="isRoundCropper ? 1 / 1 : (aspectRatio || 16 / 9)"
    [containWithinAspectRatio]="containWithinAspectRatio"
    [cropperMinHeight]="cropperMinHeight"
    [cropperMinWidth]="cropperMinWidth"
    [imageQuality]="imageQuality"
    [imageURL]="imageURL"
    [maintainAspectRatio]="maintainAspectRatio"
    [onlyScaleDown]="true"
    [resizeToHeight]="resizeToHeight"
    [resizeToWidth]="resizeToWidth"
    [roundCropper]="isRoundCropper"
    [style.display]="showCropper ? null : 'none'"
    [transform]="transform"
    backgroundColor="#FFFFFF"
    format="jpeg"
    outputType="blob"
    style="height: auto; max-height: 70vh"
  ></image-cropper>
</div>

<div>
  <div class="flex justify-content-center align-items-center">
    -
    <div class="mx-3">
      <p-slider
        class="zoom-slider ml-1 mr-1"
        (onChange)="onZoomSlider($event)"
        [(ngModel)]="zoomValue"
        [max]="maxZoom"
        [min]="minZoom"
        [step]="0.08"
        [style]="{ 'background-color': '#4d4d4d' }"></p-slider>
    </div>
    +
  </div>

  <button
    pButton
    type="button"
    (click)="onCrop()"
    [ngStyle]="{ margin: '1rem', width: '100%', 'max-width': 'stretch' }"
    class="button-simple primary-btn"
  >
    {{ 'lbl_crop_and_upload' | translate }}
  </button>
</div>